<template>
  <div class="part-3">
    <div
      style="margin-top:2px;text-align: left;"
      v-if="fileListArr.length == 0 && disabled"
    >
      无附件
    </div>
    <div
      class="list"
      :class="{
        'hide-btn': disabled,
        disabled: fileListArr.length >= 5
      }"
    >
      <el-upload
        :headers="headers"
        class="files-upload"
        :action="fileUpload"
        multiple
        accept=".zip, .rar, .pdf, .png, .jpg"
        :limit="limit"
        :before-remove="handleRemove"
        :on-change="handleChange"
        :on-error="handleError"
        :before-upload="beforeUpload"
        :file-list="fileListArr"
        with-credentials
        :disabled="disabled"
        :on-preview="clickFile"
        :on-exceed="handleExceed"
      >
        <div
          class="add-file"
          @click.stop="() => {}"
          v-if="fileListArr.length >= 5"
        >
          <el-button
            :disabled="fileListArr.length >= 5 || disabled"
            style="margin-left:5px;display:block;"
            size="small"
            type="primary"
          >
            添加文件
          </el-button>
        </div>
        <div class="add-file" v-else>
          <el-button
            style="margin-left:5px;display:block;"
            size="small"
            type="primary"
          >
            添加文件
          </el-button>
        </div>
      </el-upload>
    </div>
  </div>
</template>
<script>
import { fileUpload } from '@/api/ajax';
import { getToken } from '@/tools/auth';
import Config from '@/config/index';
export default {
  props: {
    fileList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    disabled: [Boolean]
  },
  data() {
    return {
      fileListArr: [],
      fileUpload,
      limit: 5,
      headers: {
        [Config.token]: getToken()
      }
    };
  },
  methods: {
    beforeUpload(file) {
      this.$emit('before-upload', file);
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error('上传文件大小不得超过50M');
        return false;
      }
    },
    handleExceed() {
      this.$message.error(
        `上传文件数量不超过5个,还可添加${this.limit -
          this.fileListArr.length}个文件`
      );
    },
    handleError() {
      this.$emit('on-error');
    },
    handleChange(file, fileList) {
      const arr = [];
      const allUpload = fileList.every(item => {
        const { data } = item.response || {};
        const { fileUrl } =
          Object.prototype.toString.call(data) == '[object Object]' ? data : {};
        arr.push({
          name: item.name,
          url: fileUrl || item.url
        });
        return item.response || item.status == 'success';
      });
      if (allUpload) {
        this.fileListArr = arr;
        this.$emit('success', arr);
      }
    },
    handleRemove(file, fileList) {
      // this.$emit('before-remove', file, fileList);
      const index = fileList.findIndex(item => {
        return item == file;
      });
      this.fileListArr = fileList;
      this.$emit('success', fileList);
    },
    clickFile(file) {
      if (this.disabled) {
        this.$downloadFile(file.url, false, file.name);
      }
    }
  },
  mounted() {
    this.fileListArr = [...this.fileList];
  },
  watch: {
    fileList: {
      handler: function(newV) {
        this.fileListArr = [...(newV || [])];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.part-3 {
  .list {
    // &.disabled {
    //   .add-file {
    //     display: none;
    //   }
    // }
    &.hide-btn {
      margin-top: -40px;
      .add-file {
        display: none;
      }
    }
  }
}
.files-upload {
  text-align: left;
}
</style>
